module.exports = __webpack_public_path__ + "static/media/icon_taikhoan_choduyet.f1a06f70.svg";